export enum ChannelFieldInvitationErrorCode {
    API_CHANNELS_LIMIT_EXCEEDED = 'model.guest.is_valid.channels.app_error',
    API_ARCHIVED_CHANNELS_FOUND = 'app.channel.get_channels.not_found.app_error',
}
